import { useQueryDetails } from '@gogame/query';

import { loadReviews } from 'scenes/Gallery/GalleryPage/Concepts/Reviews/sources/reviews';

import { list } from './queryKeyFactory';

export const useReviews = (conceptId) => {
  return useQueryDetails(list(conceptId), () => loadReviews({ conceptId }), {
    staleTime: 1000,
  });
};
